<template>
  <div class="switcher">
    <div class="switcher__first" ref="firstSlot">
      <slot name="first" v-if="showBoth || showFirst"></slot>
    </div>
    <div class="switcher__second" ref="secondSlot">
      <slot name="second" v-if="showBoth || !showFirst"></slot>
    </div>
  </div>
</template>

<script lang="js">
  export default  {
    name: 'lms-switcher',
    props: {
      showSecond: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        showFirst: this.showSecond,
        showBoth: true,
        firstTriggerElement: null,
        secondTriggerElement: null
      }
    },
    mounted () {
      const vm = this;

      vm.toggleSlots();
    },
    methods: {
      /**
       * Shows/hides the two slots.
       *
       * @param event
       */
      toggleSlots(event) {
        if (event) {
          event.preventDefault();
        }

        const vm = this;

        // Show both so that event listeners can be added/removed.
        vm.showBoth = true;

        // Go ahead and toggle the boolean.
        vm.showFirst = !vm.showFirst;

        // Wait until the next tick. At that point the two slots will be visible.
        vm.$nextTick(() => {
          // With both slots visible, add/remove event listeners as needed.
          if (vm.showFirst) {
            vm.firstTriggerElement = vm.$refs.firstSlot.querySelector('a, button');
            vm.firstTriggerElement.addEventListener('click', vm.toggleSlots);

            if (vm.secondTriggerElement) {
              vm.secondTriggerElement.removeEventListener('click', vm.toggleSlots);
            }
          }
          else {
            vm.secondTriggerElement = vm.$refs.secondSlot.querySelector('a, button');
            vm.secondTriggerElement.addEventListener('click', vm.toggleSlots);

            if (vm.firstTriggerElement) {
              vm.firstTriggerElement.removeEventListener('click', vm.toggleSlots);
            }
          }

          // Set the first focusable element for the freshly shown slot.
          vm.setFirstFocusable();

          // Only show the appropriate slot.
          vm.showBoth = false;
        });
      },
      /**
       * Finds the first focusable element in the current visible slot, and sets focus to it.
       */
      setFirstFocusable() {
        const vm = this;

        let slot = null;
        if (vm.showFirst) {
          slot = vm.$refs.firstSlot;
        }
        else {
          slot = vm.$refs.secondSlot;
        }

        let focusable = slot.querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');
        focusable = Array.prototype.slice.call(focusable);
        focusable[0].focus();
      }
    },
}
</script>
